const initialState: any[] = [];

const commonReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default commonReducer;
